import styled from "styled-components";
import {Button, Input} from "antd";

export const SigninForm = styled.div`
  width: 100%;
  padding: 40px 70px;
`;

export const SigninHeader = styled.div`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #14161B;  
  padding-bottom: 30px;
`;

export const SigninError = styled.div`
  padding: 20px 0;
`;

export const SigninBody = styled.div`
  //padding: 50px 80px 30px;
`;

export const SigninFooter = styled.div`
  padding-top: 20px;
  align-items: center;
  display: flex;
  flex-flow: column;
`;

export const SigninButton = styled(Button)`
  width: 175px;
  height: 44px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  border-radius: ${props => props.theme.button_border_radius};
  
  &:disabled{
    background: #98A3B9;
    color: #FFFFFF;
  }
`

export const SigninInput = styled(Input)`
  height: 42px;
  border: ${props => props.theme.login_input_border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.login_border_radius};
`
export const SigninPasswordInput = styled(Input.Password)`
  height: 42px;
  border: ${props => props.theme.login_input_border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.login_border_radius};
`
